export function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}


export const getLowestValue = (data,label) => {
 const lowestValue =  data.reduce((min, obj) => {
    return obj[label] < min ? obj[label] : min;
  }, Infinity);
  return lowestValue;
}


export const highestValue = (data,label) => {

 
  const highestValue = data.reduce((max, obj) => {
    return obj[label] > max ? obj[label] : max;
  }, -Infinity);
  return highestValue
  
}

/**
 * Format patient count to nearest 5000 with '>' prefix
 * e.g., 36411 -> '>35k'
 * @param {number} count - The patient count to format
 * @return {string} Formatted count
 */
export const formatPatientCount = (count) => {
  // Special case for 0
  if (count === 0) return '0';
  
  // Round down to nearest 5000
  const roundedDown = Math.floor(count / 5000) * 5000;
  
  // Format with the appropriate suffix
  if (roundedDown === 0) return '0-5000';
  return `>${roundedDown/1000}k`;
};

/**
 * Format site count to nearest 10 with '>' prefix
 * e.g., 12 -> '>10'
 * @param {number} count - The site count to format
 * @return {string} Formatted count
 */
export const formatSiteCount = (count) => {
  // Special case for 0
  if (count === 0) return '0';
  
  // Round down to nearest 10
  const roundedDown = Math.floor(count / 10) * 10;
  
  // Format with the appropriate suffix
  if (roundedDown === 0) return '0-10';
  return `>${roundedDown}`;
};

/**
 * Format HCP count to nearest 50 with '>' prefix
 * e.g., 132 -> '>100'
 * @param {number} count - The HCP count to format
 * @return {string} Formatted count
 */
export const formatHCPCount = (count) => {
  // Special case for 0
  if (count === 0) return '0';
  
  // Round down to nearest 50
  const roundedDown = Math.floor(count / 50) * 50;
  
  // Format with the appropriate suffix
  if (roundedDown === 0) return '0-50';
  return `>${roundedDown}`;
};